/**
 * Created by piotr.pozniak@thebeaverhead.com on 18/07/2023
 */
import React from "react";
import QueueJobsListPage from "./QueueJobsPage/QueueJobsListPage";

const QueuedSyncJobs = () => (
  <QueueJobsListPage
    title="Sync jobs"
    jobType="Integration"
    routeBase="/sync-jobs"
    hasDuration
    hasAutoLogin
  />
);

export default QueuedSyncJobs;
